<template>
    <div>
        <div  class="dsp-map">
            <a :href="dsp.schoolSearchUrl" class="img">
                <img :src="glb.welcomeImage" :alt="'School Map for ' + dsp.districtName" loading="lazy" />
            </a>
        </div>
        <div class="btn primary regular">
            <a :href="dsp.schoolSearchUrl" :title="'Homes for Sale in ' + dsp.districtName"> Find Homes for Sale in this School Zone </a>
        </div>
    </div>
</template>
<script src="./dsp-map.js"></script>
<style lang="scss">
@use "./dsp-map.scss" as *;
</style>